import { render, staticRenderFns } from "./GroupTask.vue?vue&type=template&id=4748d64e&lang=pug"
import script from "./GroupTask.vue?vue&type=script&lang=js"
export * from "./GroupTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports